export default __webpack_public_path__ + "static/media/hand.b9105174.png";